import React from "react";
import { Modal, View, StyleSheet, Image, TouchableOpacity } from "react-native";
import Text from "@components/CustomText";
import Success from "@assets/images/success-modal.webp";
import color from "@constants/color";
import Button from "@components/Button";
import Cross from "@assets/svg/Cross";
import t from "@constants/localization";

const CratePackedModal = ({
  cratePackedModalVisible,
  setcratePackedModalVisible,
  onPressBtn,
  onPressCross,
  type,
}) => {
  const PATH =
    "screens/MyDeliveries/SortingDeliveries/components/cratePackedModal";
  return (
    <Modal
      animationType="slide"
      visible={cratePackedModalVisible}
      onRequestClose={() => {
        setcratePackedModalVisible(false);
      }}
    >
      <View style={styles.centeredView}>
        <View style={styles.cross}>
          <TouchableOpacity
            testID="sd-pack-crate-modal-close"
            onPress={onPressCross}
          >
            <Cross width={20} height={20} />
          </TouchableOpacity>
        </View>
        <Image style={{ width: 122, height: 120 }} source={Success} />
        <Text
          variant="subtitle_20"
          style={{ marginVertical: 20, lineHeight: 30 }}
        >
          {type === "CRATE" ? t(`${PATH}/crateText`) : t(`${PATH}/itemText`)}
        </Text>
        <Button
          btnText={
            type === "CRATE" ? t(`${PATH}/cratebtn`) : t(`${PATH}/itembtn`)
          }
          onPress={onPressBtn}
          buttonWidth="75%"
          buttonColor={color.plain_green}
          buttonStyle={{ borderRadius: 10 }}
          height={48}
        />
      </View>
    </Modal>
  );
};

export default CratePackedModal;

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#E6F7EF",
    paddingBottom: 50,
  },
  cross: {
    position: "absolute",
    top: 20,
    left: 20,
  },
});
